import axios from 'axios';
import { getAuthToken, setAuthToken } from './authUtils';
import config from '../config';

const studentApiService = axios.create({
  baseURL: config.apiUrl, 
});

studentApiService.interceptors.request.use(
  (config) => {
    const authToken = getAuthToken('student');
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

studentApiService.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('stoken');
      window.location.href = '/student';
      console.error('Authentication error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default studentApiService;
